import React, { useEffect, useState, Suspense, lazy } from 'react';

import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';

// Import Routes all
import {
  userRoutes,
  authRoutes,
  clientRoutes,
  dashBoardsRoutes,
} from './routes/allRoutes';

//redux
import { useSelector,useDispatch } from 'react-redux';
// Import all middleware
import Authmiddleware from './routes/middleware/Authmiddleware';

// layouts Format
import VerticalLayout from './components/VerticalLayout/';
import NonAuthLayout from './components/NonAuthLayout';
import { useHistory } from 'react-router-dom';
// Import scss
import './assets/scss/theme.scss';
import './assets/scss/preloader.scss';

import fakeBackend from './helpers/AuthType/fakeBackend';
import { updateStyleDocument } from './helpers/tools_helper';

//api config
import config from './config';
import { logoutUser } from './store/actions';
import Swal from 'sweetalert2';
import LogoutRedirect from './components/Common/LogoutRedirect/LogoutRedirect';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const DashboardPW = lazy(() => import('./pages/DashboardPW'));

// Activating fake backend
fakeBackend();

const App = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [theme, setThemeState] = useState({});
  const [shouldRedirectToLogout,setShouldRedirectToLogout]= useState(false);

  const storedBrand = localStorage.getItem('brand');
  const textDescription = "We move You enjoy";

  useEffect(() => {
    const brand = storedBrand ? JSON.parse(storedBrand) : {};
    // Without a brand (e.g. login page) keep the default icon from index.html
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon instanceof HTMLLinkElement && brand.urlFavicon) {
      favicon.href = brand.urlFavicon;
    }
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && brand.name) {
      metaDescription.setAttribute('content', `${brand.name}:${textDescription}`);
    }
  }, [storedBrand]);

  useEffect(() => {
    let theme = {};
    theme = updateStyleDocument();
    if (theme === null || theme === undefined) {
      setTimeout(() => {
        updateStyleDocument();
      }, 3000);
    }
  }, []);

  const { layoutType } = useSelector((state: any) => ({
    layoutType: state.Layout.layoutType,
  }));


  useEffect(() => {
    const checkSessionTimeout = setInterval(() => {
      const currentTime = Date.now();
      const sessionTimeout = 3600000; // 1 hora en milisegundos
      const lastInteraction = Number(localStorage.getItem("lastRequest"));

      if(lastInteraction){
        if (currentTime - lastInteraction > sessionTimeout) {
          setShouldRedirectToLogout(true);
          Swal.fire({
            icon: 'error',
            title: 'Session ended',
            text: 'Your session was closed due to inactivity',
            showConfirmButton: true,
        })

        }
      }
    }, 60000);

    return () => clearInterval(checkSessionTimeout);
  }, []);



  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      return originalFetch.apply(this, args)
        .then(response => {
          return response;
        })
        .finally(() => {
          executeAfterRequest();
        });
    };
  }, []);

  function executeAfterRequest() {
    if(localStorage.getItem('authUser')){
      localStorage.setItem("lastRequest",Date.now().toString())
    }else{
      localStorage.removeItem("lastRequest");
    }
  }

  useEffect(()=>{
    if(shouldRedirectToLogout){
      setShouldRedirectToLogout(false);
    }
  },[shouldRedirectToLogout])

  


  function getLayout() {
    let layoutCls: Object = VerticalLayout;
    switch (layoutType) {
      // case "horizontal":
      //   layoutCls = HorizontalLayout;
      //   break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();
  return (
    <React.Fragment>
      <Router>

      {shouldRedirectToLogout && <LogoutRedirect />}
        <Switch>
          {authRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}

          {userRoutes.map((route: any, idx: number) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              exact
            />
          ))}

          {dashBoardsRoutes.map((route: any, idx: number) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              exact
            />
          ))}

          {clientRoutes.map((route: any, idx: number) => (
            <Route
              exact
              path={route.path}
              component={route.component}
              key={idx}
            />
          ))}
          {/* 
          <Suspense fallback={<div>Loading...</div>}>
              <Route
                exact
                path='/dashboard'
                component={Dashboard}
              />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
              <Route
                exact
                path='/dashboardPW'
                component={DashboardPW}
              />
          </Suspense> */}
        </Switch>
      </Router>
    </React.Fragment>
  );
};

export default App;
